module.exports = __webpack_public_path__ + "public/img/home_main2_img3@1x.513bc996.png";